import { Routes } from '@angular/router';

export const visitSummaryRoutes: Routes = [
  {
    path: 'summary',
    loadComponent: () =>
      import('./subscription-activation/subscription-activation.component').then(
        (m) => m.SubscriptionActivationComponent,
      ),
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./subscription-confirmation/subscription-confirmation.component').then(
        (m) => m.SubscriptionConfirmationComponent,
      ),
  },
  {
    path: 'schedule',
    loadComponent: () =>
      import('./schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
  },
  {
    path: 'schedule-confirmation',
    loadComponent: () =>
      import('../../shared/pages/flow-schedule-confirmation/flow-schedule-confirmation.page').then(
        (m) => m.FlowScheduleConfirmationPage,
      ),
    data: { flowType: 'visitSummary' },
  },
];
